// extracted by mini-css-extract-plugin
export var li = "_ub-2";
export var ol = "_ub-1";
export var ul = "_ub-0";